import { endOfDay, startOfMonth, lastDayOfMonth } from 'date-fns';
import {
  parseSearchBooleanValue,
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { DoNotCallRestrictionType } from 'infrastructure/enums';
import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';

export type TNormalReadingsFilter = {
  page: number;
  startDate: number;
  endDate: number;
  interactionStatus?: boolean;
  doNotCallRestrictionType?: DoNotCallRestrictionType;
  clinicGuid?: string;
};

const today = new Date();
const startOfTodayMonthDay = startOfMonth(today);
const lastDayOfTodayMonth = lastDayOfMonth(today);
const endOfTodayMonthDay = endOfDay(lastDayOfTodayMonth);

const defaultFilter: TNormalReadingsFilter = {
  page: 1,
  startDate: startOfTodayMonthDay.getTime(),
  endDate: endOfTodayMonthDay.getTime(),
};

const parseFunctions: TParseFunctions<TNormalReadingsFilter> = {
  page: parseSearchNumberValue,
  interactionStatus: parseSearchBooleanValue,
  doNotCallRestrictionType: parseSearchStringValue,
  clinicGuid: parseSearchStringValue,
  startDate: parseSearchNumberValue,
  endDate: parseSearchNumberValue,
};

export const useNormalReadingsFilter = () => {
  return useQueryFilterNew<TNormalReadingsFilter>(
    defaultFilter,
    parseFunctions,
    ['page', 'startDate'],
  );
};
